import { faker } from '@faker-js/faker';

export default (count = 20) => {
  const mockData = new Array(count).fill({}).map((_, i) => ({
    id: i + 1,
    state: faker.helpers.arrayElement(['accepted', 'snoozed']),
    createdAt: faker.date.past(),
    incidentType: faker.helpers.arrayElement([
      'unclaimed_prio',
      'late_eta_to_pickup',
      'pickup_delay',
      'b2b_conflict',
      'no_tracking',
      'trip_delay',
      'dropoff_delay',
      'off_route',
      'vehicle_currently_stopped',
      'rider_assistant_unassigned_prio',
      'late_eta',
    ]),
    timeZoneName: 'America/Los_Angeles',
    tripSlug: faker.string.alphanumeric(10),
    tripEta: faker.date.past(),
    tripStartsAt: faker.date.future(),
    tripEndsAt: faker.date.future(),
    tripAccountSlug: faker.string.alphanumeric(10),
    tripAccountName: `Fake ${faker.company.name()} School`,
    metroAreaName: 'LA',
    regionName: `${faker.location.city()} - ${faker.location.cardinalDirection()}`,
    driverName: faker.person.fullName(),
    organizerNames: [faker.person.fullName()],
    passengerNames: faker.helpers.arrayElements([
      faker.person.fullName(),
      faker.person.fullName(),
      faker.person.fullName(),
      faker.person.fullName(),
    ]),
    assigneeName: faker.helpers.arrayElement([faker.person.fullName(), null]),
    assigneeId: faker.helpers.arrayElement([faker.string.numeric(), null]),
    highPriority: faker.datatype.boolean(),
  }));

  return mockData as unknown as Alerts[];
};
